import { cn } from "../../../../../utils/cn";
import {
  ACTIVE_TENANT,
  TENANT_BG_CLASSES,
} from "../../../../../constants/tenant_colors";

interface IMySchedulesCardProps {
  className?: string;
  onAccess: () => void;
}

export const MySchedulesCard = ({
  className,
  onAccess,
}: IMySchedulesCardProps) => {
  return (
    <div
      className={cn(
        TENANT_BG_CLASSES[ACTIVE_TENANT],
        "flex flex-col justify-between rounded-[10px] w-full max-w-md p-8",
        className,
      )}
    >
      <div>
        <img
          src="/assets/svgs/icon-calendar-search.svg"
          alt="icone calendario"
          className="mb-20"
        />
      </div>

      <div className="mb-5">
        <h3 className="text-2xl text-white font-extrabold mb-2">
          Meus agendamentos
        </h3>
        <p className="text-sm text-white">
          Acompanhe vistorias agendadas, veja histórico e reagende quando
          precisar
        </p>
      </div>

      <button
        onClick={onAccess}
        className="flex gap-3 items-center text-white py-4"
      >
        Acessar
        <img
          alt="seta para a direira"
          src="/assets/svgs/icon-arrow-forward.svg"
        />
      </button>
    </div>
  );
};
